import { useState, useCallback } from 'react';
import api from '../api';

export function useAgent2Queue() {
  const [agent2Status, setAgent2Status] = useState(null);
  const [agent2QueueHistory, setAgent2QueueHistory] = useState([]);

  const fetchAgent2QueueHistory = useCallback(async () => {
    try {
      const res = await api.get('/agent2_queue/history');
      if (res.data) {
        setAgent2Status(res.data.status);
        setAgent2QueueHistory(res.data.history || []);
      }
    } catch (err) {
      console.warn("Erro ao buscar histórico da fila Agente 2:", err);
    }
  }, []);

  const startAgent2Queue = useCallback(async (limit = null) => {
    try {
      const res = await api.post('/admin/agent2_queue/start', { limit });
      if (res.data && res.data.status === 'error') {
        alert(res.data.message);
        return;
      }
      await fetchAgent2QueueHistory();
    } catch (err) {
      console.warn("Erro ao iniciar Agente 2 (Fila):", err);
      alert("Erro ao iniciar a fila do Agente 2. Verifique o console.");
    }
  }, [fetchAgent2QueueHistory]);

  const stopAgent2Queue = useCallback(async () => {
    try {
      await api.post('/admin/agent2_queue/stop');
      await fetchAgent2QueueHistory();
    } catch (err) {
      console.warn("Erro ao parar Agente 2 (Fila):", err);
    }
  }, [fetchAgent2QueueHistory]);

  return {
    agent2Status,
    agent2QueueHistory,
    fetchAgent2QueueHistory,
    startAgent2Queue,
    stopAgent2Queue
  };
}
